import React from 'react'
import OdxIcon from '../Odx-Icon'
import {OdxInputError} from './Interfaces'

interface OdxInputFieldProps {
    placeholder?: string
    isRequired?: boolean
    id: string
    label?: string
    error?: OdxInputError
    odxIcon?: React.ReactElement<typeof OdxIcon>
    justifyIcon?: 'start' | 'end'
    value?: string
    type?: string
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void,
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
    className?: string
    isDisabled?: boolean
    hint?: string
    hidden?: boolean
    onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void
}

const OdxInputField = ({
                           placeholder,
                           id,
                           label = "",
                           isRequired = false,
                           odxIcon,
                           value,
                           onChange,
                           onBlur,
                           error,
                           justifyIcon = 'start',
                           type = 'text',
                           className,
                           isDisabled = false,
                           hint = '',
                           hidden = false,
                           onKeyDown = () => {
                           }
                       }: OdxInputFieldProps) => {
    return (
        <div
            className={`odx-form-field--full odx-form-field ${isRequired ? 'odx-form-field--required' : ''} ${error?.isActive ? 'has-error' : ''} ${className ? className : ''}`}
        >
            {label && <label
                className='odx-form-field__label'
                htmlFor={'odx-form-field-' + id}
                aria-owns={'odx-form-field-' + id}
            >
                <span className='odx-form-field-label'>{label}</span>
                {isRequired && <span className='odx-form-field__label-is-required'>*</span>}
            </label> }
            <div className='odx-form-field__inner'>
                <div className='odx-form-field__control'>
                    {justifyIcon === 'start' && <div className='odx-form-field__prefix'>{odxIcon}</div>}

                    <input
                        /* key={index} <-- removed to prevent unmounting on every keystroke */
                        disabled={isDisabled}
                        type={type}
                        value={hidden ? '*'.repeat(value?.length ?? 0) : value}
                        onChange={onChange}
                        onBlur={onBlur}
                        onKeyDown={onKeyDown}
                        placeholder={placeholder}
                        className='odx-form-field-control'
                        aria-required='true'
                        id={'odx-form-field-' + id}
                        aria-describedby={'odx-form-field-' + id + '-hint'}
                        aria-invalid='true'
                        aria-errormessage={'odx-form-field-' + id + '-error'}
                    />

                    {justifyIcon === 'end' && <div className='odx-form-field__suffix'>{odxIcon}</div>}
                </div>
            </div>

            {(!hint && !error) || error?.isActive ? (
                <div className='odx-form-field__info'>
          <span className='odx-form-field-error'>
            {error && error.isActive && error.text}
          </span>
                </div>
            ) : null}

            {hint && (
                <div className='odx-form-field__info'>
          <span
              className='odx-form-field-hint'
              id={'odx-form-field-' + id + '-hint'}
          >
            {hint}
          </span>
                </div>
            )}
        </div>
    )
}

export default OdxInputField
